<template>
<main class="container-1">

    <div class="container-header">
        <Breadcrumb
        v-bind:links="routesBread"
        >
        </Breadcrumb>
        <!-- <h2>Listado</h2> -->
        <TabNav :links="routesNav" />
    </div>

    <div class="container-body">

        <div class="maps-filter">
            <input
            id="search"
            v-model="search"
            type="text"
            placeholder="Buscar mapa..."
            class="maps-search" />
        </div>

        <div class="maps-list">
            <router-link
            v-for="item in pagedMaps"
            :key="item.id"
            :to="'/mapas/' + item.id"
            class="map-row"
            >
                <span class="map-row__icon" aria-hidden="true">{{ item.name ? item.name.charAt(0).toUpperCase() : 'M' }}</span>
                <span class="map-row__info">
                    <span class="map-row__name">{{ item.name }}</span>
                    <span class="map-row__meta">
                        <span v-if="item.desc" class="map-row__desc">{{ item.desc }}</span>
                        <span class="map-row__date">Creado {{ dateFormatter(item.created_at) }}</span>
                    </span>
                </span>
                <span class="map-row__chevron" aria-hidden="true">&rsaquo;</span>
            </router-link>

            <p v-if="!filteredMaps.length" class="maps-empty">
                {{ search ? 'No hay mapas que coincidan con la búsqueda.' : 'Aún no hay mapas creados.' }}
            </p>

        </div>

        <Pagination
        v-show="pageCount > 1"
        v-bind:totalPages="pageCount"
        v-bind:currentPage="currentPage"
        v-bind:pageSize="pageSize"
        v-on:pagechanged="onPageChanged"
        >
        </Pagination>

    </div>

    <!-- <SideNav
    class="container-sidenav"
    v-bind:links="routesNav"
    >
    </SideNav> -->
    
</main>
</template>

<script>
// @ is an alias to /src
import SideNav from '@/components/SideNav.vue'
import Breadcrumb from '@/components/Breadcrumb.vue'
import TabNav from '@/components/TabNav.vue'
import Pagination from '@/components/Pagination.vue'

import {formatter} from '@/components/mixin/formatter.js'
import {restMap} from '@/components/mixin/restMap.js'

export default{
    name: 'test',
    mixins: [formatter, restMap],
    data(){
        return{
            currentPage: 1,
            pageSize: 10,
            search: ''
        }
    },
    components:{
        SideNav,
        Breadcrumb,
        Pagination,
        TabNav
    },
    computed: {
        routesNav: function(){
          return [
                {name:'Opciones'},
                {name:'Crear mapa' , path: '/mapas/nuevo-mapa'},
              ]
        },
        routesBread: function(){
          return [
              {name: 'Mapas'}
          ]
        },
        // Búsqueda por nombre o descripción (cliente, sobre todos los mapas)
        filteredMaps: function(){
            var list = this.maps || [];
            var text = this.search.trim().toLowerCase();
            if (!text) {
                return list;
            }
            return list.filter(function(map){
                var name = (map.name || '').toLowerCase();
                var desc = (map.desc || '').toLowerCase();
                return name.indexOf(text) !== -1 || desc.indexOf(text) !== -1;
            });
        },
        // Paginación cliente: siempre acotada, nunca se pasa del límite
        pageCount: function(){
            return Math.max(1, Math.ceil(this.filteredMaps.length / this.pageSize));
        },
        pagedMaps: function(){
            var start = (this.currentPage - 1) * this.pageSize;
            return this.filteredMaps.slice(start, start + this.pageSize);
        }
    },
    watch: {
        search: function(){
            // Al buscar, volver a la primera página
            this.currentPage = 1;
        },
        pageCount: function(count){
            // Si el filtro reduce las páginas, no quedar en una inexistente
            if (this.currentPage > count) {
                this.currentPage = count;
            }
        }
    },
    props: [],
    methods:{
        onPageChanged: function (page){
            // Clamp defensivo: currentPage siempre dentro de [1, pageCount]
            this.currentPage = Math.min(Math.max(1, page), this.pageCount);
        }
    },
    updated () {

    },
    created () {
        this.$store.getters.getPermissions.maps? true:this.$router.push('/pagina-no-encontrada')
    }, 
    mounted () {
        this.getMapsNoPages();
    }
}
</script>

<style lang="scss" scoped>
.maps-filter {
    margin: 0.6rem 0 0.3rem;
}

.maps-search {
    width: 100%;
    max-width: 360px;
    padding: 0.5em 0.7em;

    border: 1px solid var(--color-line);
    border-radius: 7px;
    background: var(--color-white);
    color: var(--color-graphite);

    font-family: inherit;
    font-size: 0.9rem;
}

.maps-search:focus {
    outline: none;
    border-color: var(--color-steel);
    box-shadow: 0 0 0 3px rgba(59, 110, 148, 0.15);
}

.maps-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    margin: 0.6rem 0;
}

/* Cada mapa es una fila-tarjeta clickeable de ancho completo (sin columnas vacías) */
.map-row {
    display: flex;
    align-items: center;
    gap: 0.85rem;

    padding: 0.8rem 1rem;

    background: var(--color-white);
    border: 1px solid var(--color-line);
    border-radius: 8px;

    text-decoration: none;
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.map-row:hover {
    border-color: var(--color-steel);
    box-shadow: 0 2px 10px rgba(14, 42, 64, 0.08);
    text-decoration: none;
}

.map-row:focus-visible {
    outline: 2px solid var(--color-orange);
    outline-offset: 2px;
}

.map-row__icon {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;

    width: 38px;
    height: 38px;
    border-radius: 9px;

    background: rgba(59, 110, 148, 0.14);
    color: var(--color-steel);
    font-weight: 800;
    font-size: 1.05rem;
}

.map-row__info {
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    min-width: 0;
    flex: 1;
}

.map-row__name {
    font-size: 1.02rem;
    font-weight: 700;
    color: var(--color-navy);

    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.map-row__meta {
    display: flex;
    flex-wrap: wrap;
    gap: 0.15rem 0.6rem;
    font-size: 0.8rem;
    color: var(--color-ghost);
}

.map-row__desc {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 44ch;
}

.map-row__chevron {
    flex-shrink: 0;
    font-size: 1.6rem;
    line-height: 1;
    color: var(--color-ghost);
    transition: color 0.15s ease;
}

.map-row:hover .map-row__chevron {
    color: var(--color-orange);
}

.maps-empty {
    margin: 0;
    padding: 3rem 1rem;
    text-align: center;
    color: var(--color-ghost);
    font-style: italic;
}
</style>
